import React from 'react';

import {observer} from 'mobx-react';
import {WebsiteModuleProps} from "../../models/website-module.props";
import {SideBarModuleAsync} from "../../modules/side-bar-module/components/side-bar-module.async";
import styles from "../../styles/website.module.scss";
import classnames from "classnames";

export const WebsiteModuleSideBar = observer(({controller}: WebsiteModuleProps) => {
  const {state} = controller;
  const {competitor} = state.entitiesContext;

  return (
    controller.state.displaySettings.sideBarVisible && <div className={classnames(styles.side_bar)}><SideBarModuleAsync competitorId={competitor?.id}/></div>
  )
});
